import React from "react";

const CanadianCollegeCrisis = () => {
  return (
    <div>
      <div className="single mt-125">
        <div className="container" style={{ marginTop: "20px" }}>
          <div className="section-header">
            <h2>Ontario Colleges Cut Programs Amid Growing Financial Crisis</h2>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="details-image">
                <img
                  src="img/Blogs/Ontario Colleges Cut Programs Amid Growing Financial Crisis.png"
                  alt="Ontario Colleges Cut Programs Amid Growing Financial Crisis"
                  style={{
                    marginTop: "30px",
                    maxHeight: "400px",
                    maxWidth: "80%",
                  }}
                />
              </div>
              <div className="details-text">
                <h2>Colleges Slashing Programs Province-Wide</h2>
                <p>
                  Public colleges across Ontario are making urgent and sweeping
                  program cuts as a financial crisis deepens across the sector.
                  Dozens of diploma and certificate programs are being
                  suspended—from business and creative arts to tourism,
                  technology, and esthetics—as institutions like Algonquin,
                  George Brown, Mohawk, St. Lawrence, and Centennial move to
                  rein in costs before the 2025–26 budget year.
                </p>
                <p>
                  Many of the cuts are to popular in-person programs, sparking
                  concern among students and educators about access to education
                  in their communities. The list of suspended programs is often
                  similar across institutions, leaving some regions with fewer
                  local post-secondary options.
                </p>

                <hr />

                <h2>The Numbers: A System on the Brink</h2>
                <ul>
                  <li>
                    Ontario colleges say they are on track to lose $60 million
                    in 2025–2026.
                  </li>
                  <li>
                    That number could balloon to $93 million by 2026–2027 if no
                    changes are made.
                  </li>
                  <li>
                    Algonquin College alone has grown revenues from $415 million
                    in 2020 to $531 million in 2024, but expects a steep drop
                    due to falling international enrolment.
                  </li>
                  <li>
                    Ontario colleges receive $6,553 per full-time student,
                    compared to the national average of $16,019—just 41% of what
                    colleges in other provinces receive.
                  </li>
                </ul>

                <hr />

                <h2>International Students Were the Lifeline</h2>
                <p>
                  For over a decade, Ontario colleges have relied heavily on
                  tuition from international students to stay afloat. At some
                  colleges, international students bring in three to four times
                  the revenue of domestic students. International enrolment has
                  often been concentrated in business programs, which are now
                  being suspended due to changes in federal immigration policy.
                </p>
                <p>
                  Colleges counted on those students not just for tuition, but
                  also because many enrolled in programs eligible for
                  post-graduate work permits. However, as of September 2024,
                  those permits are restricted to graduates in only a handful of
                  sectors: agriculture, education, healthcare, trades,
                  transport, and STEM fields.
                </p>
                <p>
                  Algonquin College, for example, had been increasing
                  international enrolment by over 20% annually, with
                  international students now representing one in three of its
                  25,000 students. But the college anticipates that number will
                  drop back to one in five as new caps take effect.
                </p>

                <hr />

                <h2>Popular Domestic Programs Also Affected</h2>
                <p>
                  The impact isn’t limited to international-heavy programs.
                  Domestic students are also feeling the squeeze, with programs
                  like hairstyling, esthetics, photography, and scriptwriting
                  getting the axe despite strong local demand.
                </p>
                <p>
                  Faculty and union representatives worry that programs tied to
                  real community needs—but which are expensive to run—are being
                  eliminated because they don’t generate enough tuition revenue
                  to break even. At Algonquin, a dozen creative arts and media
                  programs have been cut, and entire faculties are being
                  downsized.
                </p>

                <hr />

                <h2>No Relief in Sight From the Province</h2>
                <p>
                  Despite repeated warnings—including a 2021 Ontario Auditor
                  General report highlighting the risks of international student
                  dependence—provincial policy has remained largely unchanged.
                </p>
                <ul>
                  <li>
                    Domestic tuition has been frozen since 2019, when the Ford
                    government reduced it by 10%.
                  </li>
                  <li>
                    That freeze is set to continue until at least 2026–2027.
                  </li>
                  <li>
                    Colleges cannot raise fees or expand domestic enrolment
                    without hitting a funding cap due to the province’s corridor
                    model, which doesn't provide extra money for added students.
                  </li>
                </ul>
                <p>
                  In fact, students in 2027 will be paying the same tuition they
                  did back in 2015, even as program delivery costs have risen by
                  25% over the past decade.
                </p>

                <hr />

                <h2>What Comes Next?</h2>
                <p>
                  Colleges say that unless the Ontario government steps in with
                  a revised funding model, further cuts are inevitable.
                  Algonquin president Claude Brulé warned that many programs are
                  no longer financially viable under current policies, and that
                  institutions can’t keep up with rising costs without the
                  ability to grow international enrolment or raise domestic
                  tuition.
                </p>
                <p>
                  “This is the fire in front of us,” said faculty union
                  president Tracy Henderson, “but it’s not the only one. We are
                  here as a direct result of chronic underfunding.”
                </p>
                <p>
                  As the situation worsens, some advocates are calling for
                  post-secondary funding—and the future of Ontario colleges—to
                  become a major issue in the next provincial election.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanadianCollegeCrisis;
